module.exports = __webpack_public_path__ + "static/coolhouseranch-388f9bb321d8b1c70c5f2704f5b99613.jpg";